import { Button, Card, Center, Stack, Text, Title } from '@mantine/core';
import { IconFolderPlus } from '@tabler/icons-react';

export function EmptyProjectState({ onCreate }: { onCreate: () => void }) {
  return (
    <Center h="60vh">
      <Card maw={460} ta="center">
        <Stack align="center" gap="sm">
          <IconFolderPlus size={32} stroke={1.5} />
          <Title order={3} fz="lg">No projects yet</Title>
          <Text size="sm" c="dimmed">
            A project is one tenant: its own profiles, integrations, templates, and
            API keys. Nothing is shared between projects.
          </Text>
          <Button mt="xs" onClick={onCreate}>Create your first project</Button>
        </Stack>
      </Card>
    </Center>
  );
}
